// Golf Match Play Tracker 2026 -- Helpers

export function uid(prefix = "id") {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
}

// "16:50" -> "4:50 PM"
export function formatTime(t) {
  if (!t) return "";
  const [h, m] = t.split(":");
  const hour = Number(h);
  const ampm = hour >= 12 ? "PM" : "AM";
  const hr12 = ((hour + 11) % 12) + 1;
  return `${hr12}:${m} ${ampm}`;
}

// "16:50" + 10 -> "17:00"
export function addMinutes(t, minutes) {
  const [h, m] = t.split(":").map(Number);
  const total = h * 60 + m + minutes;
  const hh = Math.floor(((total % 1440) + 1440) % 1440 / 60);
  const mm = ((total % 1440) + 1440) % 1440 % 60;
  return `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`;
}

// Build a list of tee times from a start, interval and count.
export function teeTimeSlots(firstTeeTime, intervalMin, count) {
  const out = [];
  for (let i = 0; i < count; i++) out.push(addMinutes(firstTeeTime, intervalMin * i));
  return out;
}

// "2026-09-01" -> "Tue, Sep 1"
export function formatDate(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  return dt.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
}

export function byName(a, b) {
  return (a?.name || "").localeCompare(b?.name || "");
}

// Read a flat pairings array two at a time -> [[a,b],[c,d]]
export function pairsFromPairings(pairings = []) {
  const out = [];
  for (let i = 0; i + 1 < pairings.length; i += 2) out.push([pairings[i], pairings[i + 1]]);
  return out;
}

export function golferMap(golfers = []) {
  const m = new Map();
  golfers.forEach(g => m.set(g.id, g));
  return m;
}
